import { render, staticRenderFns } from "./DocumentListView.vue?vue&type=template&id=218fc440&scoped=true"
import script from "./DocumentListView.vue?vue&type=script&lang=js"
export * from "./DocumentListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218fc440",
  null
  
)

export default component.exports